/**
 * External dependencies
 */
export default class ConnectionPaymentTypes {
    constructor(id, cscom) {
        if (!(this instanceof ConnectionPaymentTypes)) {
            return new ConnectionPaymentTypes(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/user-connection-payment-types/${this.id}`;
        } else {
            this.path = `/user-site-api/user-connection-payment-types`;
        }
    }

    getConnectionPaymentTypes() {
        return this.cscom.req.get(this.path);
    }

    update(body) {
        return this.cscom.req.put(this.path, body).then((result) => {
            return result;
        });
    }

    add(body) {
        return this.cscom.req.post(this.path, body).then((result) => {
            return result;
        });
    }

    remove() {
        return this.cscom.req.del(this.path).then((result) => {
            return result;
        });
    }
}
